module.exports = __webpack_public_path__ + "static/media/WaywardCreatures.61a7d7bb.jpg";